module.exports = __webpack_public_path__ + "img/liucheng2.6c915384.png";